import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/authService';
import { User } from '../models/user';
import * as bootstrap from 'bootstrap';
import { Offcanvas } from 'bootstrap';

@Component({
  selector: 'app-cookies-notification',
  standalone: false,
  templateUrl: './cookies-notification.component.html',
  styleUrl: './cookies-notification.component.scss'
})
export class CookiesNotificationComponent {
  renderer: any;
  user = new User('', false);

  constructor(private http: HttpClient, private authService: AuthService, private el: ElementRef, renderer: Renderer2, private router: Router) {
    this.renderer = renderer;
  }

  async ngOnInit() {
    let offcanvasList: Offcanvas[] = [];
    const offcanvasElementList = document.querySelectorAll('.offcanvas')
    offcanvasList = Array.from(offcanvasElementList).map(offcanvasEl => new bootstrap.Offcanvas(offcanvasEl))
    const firstOffcanvas = offcanvasList.at(0);
    if (firstOffcanvas) {
      firstOffcanvas.show();
    }
  }
}
